<script>
	import goodstypetree from './goodstypetree/tree.vue'
	import upload from './upload/index.vue'
	import add from './add/index.vue'
	import batchdelete from './delete/index.vue'
	import preview from './preview/index.vue'
	import listBase from '@_system/components/base/list.vue'
	export default {
		extends: listBase,
		name: 'materialIndex',
		props: {

		},
		render(h) {
			this.$slots.aside = [ <goodstypetree ref = "goodstypetree" key = {this.goodstypetreeKey} onSelect = {this.goodstypetreeChange}/>]
			this.$slots.plug = [ 
				<upload ref = "upload" row={this.row} key = {this.uploadKey} onSuccess={this.uploadsuccess} />,
				<add ref = "add" row={this.row}  onSubmit={this.addSubmit}/>,
				<batchdelete ref = "batchdelete" row={this.row}  onSubmit={this.batchdeleteSubmit}/>,
				<preview ref = "preview" row={this.row} />
			]
			return listBase.render.call(this, h)
		},
		data() {
			return {
				row:null,
				goodstypetreeKey: Math.random(),
				uploadKey: Math.random(),
				moduleName: 'material',
				windowName: '材质报告',
				windowType: 'modal',
				currentCatagory: null,
				// pagerConfig: {
				// 	enabled: false,
				// },
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			beforeCreateGrid(formConfig, columns, gridOptions) {
				columns.unshift({
					title:'#',
					field:'',
					width:50,
					type:'checkbox',
					fixed:'left'
				})
				columns.forEach((item)=>{
					if(item.field=='pic'){
						item.slots = {
							default:({row})=>{
								return 	row.pic1? <el-image style="width: 30px; height: 30px" src={row.pic1} preview-src-list={[row.pic1]}></el-image> : ''
							}
						}
					}
					if(item.field=='file'){
						item.slots = {
							default:({row})=>{
								return 	this.formatterFile(row)
							}
							
						}
					}
					// if(item.field=='specCode'){
					// 	item.filters = [
					// 		{label:'123',value:123}
					// 	]
					// }
				})
				gridOptions.checkboxConfig = {}
				gridOptions.treeConfig.lazy = true
				gridOptions.treeConfig.accordion = true
				gridOptions.treeConfig.loadMethod = this.loadMethod


			},
			afterGet(res,updateForm){
				setTimeout(()=>{
					let fullData = this.$refs[this.moduleName+'_list'].getTableData().fullData
					if( (updateForm.goodsCode || updateForm.goodsName)){
						this.$refs[this.moduleName+'_list'].setTreeExpand(fullData[0], true)
					}	
				},100)
			},
			loadMethod({
				row
			}) {
				return new Promise((reslove) => {
					this.$api.material.listgoodssku({
						goodsUid: row.goodsUid
					}).then((res) => {
						//console.log(row,res)
						let parentFile = row.file
						res.forEach((item)=>{
							let file = item.file
							parentFile.forEach((_item)=>{
								let obj = file.find((fitem)=>{
									return fitem.type ==  _item.type
								})
								if(obj){
									obj.file = _item.file.concat(obj.file)
								}else{
									file.push(_item)
								}
							})
						})
						reslove(res)
					},()=>{
						reslove([])
					})
					
				})
			},
			goodstypetreeChange(e) {
				this.currentCatagory = e
				this.foreingKey.catagoryid = e.wlnid
				this.customreload()
			},
			upload(row) {
				this.row = row
				this.$refs.upload.modal_show()
			},
			batchupload(){
				let data = this.getGrid().getCheckboxRecords()
				let children = data.filter((item)=>{
					return item.hasChild!=1
				})
				console.log(children)
				if(children.length!=0){
					this.row = children
					this.$refs.add.modal_show()
				}else{
					if(data.length==0){
						this.$message.error('请选择数据')
					}else{
						this.$message.error('SPU不支持批量上传')
					}		
				}	
			},
			batchdelete(){
				//console.log(this.$refs.del)
				let data = this.getGrid().getCheckboxRecords()
				let children = data.filter((item)=>{
					return item.hasChild!=1
				})
				if(children.length!=0){
					this.row = children
					console.log(this.$refs.add,this.$refs.del)
					this.$refs.batchdelete.modal_show()
				}else{
					if(data.length==0){
						this.$message.error('请选择数据')
					}else{
						this.$message.error('SPU不支持批量删除')
					}		
				}	
			},
			addSubmit(e){
				if(e.file && e.file.length!=0){		
					let objs = []
					this.row.forEach((item)=>{
						let obj = {}
						obj.file = [e]
						obj.goodsUid = item.goodsUid
						obj.goodsCode = item.goodsCode
						obj.specUid = item.specUid
						obj.specCode = item.specCode
						objs.push(obj)
					})
					this.$api.material.batchAction({data:objs,action:'add'}).then(() => {
						this.$message.success('操作成功')
						this.customreload()
							
					})
				}
			},
			batchdeleteSubmit(e){
				let objs = []
				this.row.forEach((item)=>{
						let obj = {}
						obj.goodsUid = item.goodsUid
						obj.specUid = item.specUid
						objs.push(obj)
				})	
				this.$api.material.batchAction({data:objs,type:e.type,action:'delete'}).then(() => {
					this.$message.success('操作成功')
					this.customreload()				
				})
			},
			formatterFile(row){
				let type = []
				if(!row.hasChild){
					let file = row.file					
					if(file){
						file.forEach((item)=>{
							if(item.file.length){
								type.push(<el-link onClick={()=>{this.preview(row,item)}} type="primary" style="font-size:12px;">{item.type + '【'+item.file.length+'】'}</el-link>)							
							}		
						})
						return type
					}else{
						return null
					}
				}else{
					let statics = row.statics
					if(statics){
						for(let i in statics){
							type.push(<el-button type="text" size="mini" onClick={()=>{this.setTreeExpand(row,true)}} style="font-size:12px;">{i + '【'+statics[i]+'】'}</el-button>)
						}
						return type
					}else{
						return null
					}
				}
			},
			setTreeExpand(rows, checked){
				let grid = this.$refs[this.moduleName+'_list']
				if(grid.isTreeExpandByRow(rows)){
					this.$refs[this.moduleName+'_list'].setTreeExpand(rows, false)
				}else{
					this.$refs[this.moduleName+'_list'].setTreeExpand(rows, checked)
				}
				
			},
			preview(row,item){
				this.row = row
				row.file.forEach((file)=>{
					file.active = 0
					if(file.type == item.type){
						file.active = 1
					}
				})
				this.$refs.preview.show()
			},
			uploadsuccess(){
				this.customreload()
			}
		},
		components: {
			preview,
			batchdelete
		}
	}
</script>